<template>
  <div>
    <div class="row pl-2">
      <div class="p-2">
        <div class="input-group col-7 gap-5 abc">
          <div class="row">
            <div class="position-relative mr-1" style="width: 20rem">
              <span class="input-label font-bold">{{
                $t("usps.shipping_date_from")
              }}</span>
              <div>
                <flat-pickr
                  v-model="shippingDateFrom"
                  class="form-control invoice-edit-input invoice-input-top mt-1"
                  :placeholder="fourDaysBeforeCurrentDate"
                  :class="{ 'is-invalid': shippingDateFromInvalid }"
                />
                <feather-icon
                  v-if="shippingDateFrom === ''"
                  size="16"
                  icon="CalendarIcon"
                  class="cursor-pointer clear-all mt-fedex"
                />
                <feather-icon
                  v-else-if="!shippingDateFromInvalid"
                  size="16"
                  icon="XIcon"
                  class="cursor-pointer clear-all mt-fedex"
                  @click="shippingDateFrom = ''"
                />
              </div>
              <div v-if="shippingDateFromInvalid" class="invalid-feedback">
                Shipping Date From must be less than Shipping Date To.
              </div>
            </div>

            <div class="position-relative mr-1" style="width: 20rem">
              <span class="input-label font-bold">{{
                $t("usps.shipping_date_to")
              }}</span>
              <div>
                <flat-pickr
                  v-model="shippingDateTo"
                  class="form-control invoice-edit-input invoice-input-top mt-1"
                  :placeholder="currentDate"
                  :class="{ 'is-invalid': shippingDateToInvalid }"
                />
                <feather-icon
                  v-if="shippingDateTo === ''"
                  size="16"
                  icon="CalendarIcon"
                  class="cursor-pointer clear-all mt-fedex"
                />
                <feather-icon
                  v-else-if="!shippingDateFromInvalid"
                  size="16"
                  icon="XIcon"
                  class="cursor-pointer clear-all mt-fedex"
                  @click="shippingDateTo = ''"
                />
              </div>
              <div v-if="shippingDateToInvalid" class="invalid-feedback">
                Shipping Date From must be less than Shipping Date To.
              </div>
            </div>

            <div class="position-relative mr-1 py-fedex" style="width: 20rem">
              <span class="input-label font-bold">{{
                $t("usps.delievered_after")
              }}</span>
              <div>
                <flat-pickr
                  v-model="deliveredBy"
                  class="form-control invoice-edit-input invoice-input-top mt-1"
                  :placeholder="currentDate"
                />
                <feather-icon
                  v-if="deliveredBy === ''"
                  size="16"
                  icon="CalendarIcon"
                  class="cursor-pointer clear-all mtups-cus"
                />
                <feather-icon
                  v-else
                  size="16"
                  icon="XIcon"
                  class="cursor-pointer clear-all mtups-cus"
                  @click="deliveredBy = ''"
                />
              </div>
            </div>

            <div class="mr-1 pt-2 position-relative" style="width: 20rem">
              <span class="input-label font-bold">{{
                $t("usps.destination_zip")
              }}</span>
              <input
                v-model="zipCode"
                type="text"
                :placeholder="$t('usps.zipCode')"
                class="search-product form-control mt-1"
              />
              <span v-if="zipCodeError" class="text-danger danger-text">{{
                zipCodeError
              }}</span>
            </div>

            <!--
            <div
              style="width: 20rem;"
              class="text-center"
            >
            </div> -->
          </div>
        </div>
        <b-button
          variant="primary"
          class="float-left mt-2 mb-1 text-capitalize"
          style="margin-right: 15px; height: fit-content"
          :disabled="
            shippingDateFrom === '' ||
            shippingDateTo === '' ||
            deliveredBy === '' ||
            zipCode === '' ||
            isLoading
          "
          @click="handleClick"
        >
          <div
            v-if="isLoading"
            class="spinner-border d-flex align-items-center"
            style="height: 16px; width: 16px"
          />
          <div v-else class="">
            <feather-icon icon="FilterIcon" size="17" class="cursor-pointer" />
            <span>{{ $t("usps.apply_filters") }}</span>
          </div>
        </b-button>
      </div>
    </div>
    <template v-if="no_record_found">
      <div
        class="d-flex flex-direction-column align-items-center justify-content-center"
      >
        <div class="align-items-center justify-content-center">
          <div class="mb-1 start-chat-icon pl-3">
            <feather-icon icon="FolderIcon" size="40" />
          </div>
          <h5 class="sidebar-toggle start-chat-text">
            {{ $t("usps.no_carrier") }}
          </h5>
        </div>
      </div>
    </template>
    <b-table
      v-if="shippignItems.length || destinationItems.length"
      :fields="shippingfields"
      :items="
        shippingStatusFedex === 'shipped' ? shippignItems : destinationItems
      "
      responsive
      class="mb-0"
      show-empty
      :empty-text="'no records found'"
      empty-filtered-text
    >
      <template>
        <div class="d-flex align-items-center justify-content-center">
          <div class="mb-1 start-chat-icon">
            <feather-icon icon="FolderIcon" size="40" />
          </div>
          <h5 class="sidebar-toggle start-chat-text">no_record</h5>
        </div>
      </template>

      <template #cell(trackingNumber)="data">
        <div class="d-flex flex-column">
          <span v-if="!trackerNumber[data.item.encode]" class="font-bold">{{
            data.item.trackingNumber
          }}</span>
          <feather-icon
            v-if="!trackerNumber[data.item.encode]"
            icon="EyeIcon"
            size="16"
            class="mt-1 cursor-pointer"
            @click="handleEyeClick(data.item)"
          />
          <!-- <b-tooltip
            :target="'tooltip-button-' + data.item.encode"
            placement="top"
            triggers="hover"
          >
            show
          </b-tooltip> -->
          <a
            v-if="trackerNumber[data.item.encode]"
            :href="`https://www.fedex.com/fedextrack/?trknbr=${
              trackerNumber[data.item.encode]
            }`"
            target="_blank"
            class="cursor-pointer font-bold"
            >{{ trackerNumber[data.item.encode] }}</a
          >
          <CopyToClipboard
            ref="copyToClipboardRef"
            :key="trackerNumber[data.item.encode]"
            class="cursor-pointer"
            :text="trackerNumber[data.item.encode]"
            @copy="copyAffiliateLink(trackerNumber[data.item.encode])"
          >
            <feather-icon
              v-if="trackerNumber[data.item.encode]"
              class="cursor-pointer mt-1"
              :icon="
                copied[data.item.trackingNumber] ? 'CheckIcon' : 'CopyIcon'
              "
              size="14"
            />
          </CopyToClipboard>
        </div>
      </template>

      <template #cell(trackingStatus)="data">
        <div class="font-bold">{{ data.item.trackingStatus }}</div>
      </template>

      <template #cell(shippingDate)="data">
        <div class="font-bold">
          {{
            new Date(data.item.shippingDate).toLocaleString("en-US", {
              dateStyle: "medium",
              timeStyle: "short",
            })
          }}
        </div>
      </template>

      <template #cell(deliveryDate)="data">
        <div class="font-bold">
          {{
            new Date(data.item.deliveryDate).toLocaleString("en-US", {
              dateStyle: "medium",
              timeStyle: "short",
            })
          }}
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import {
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BLink,
  BTooltip,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import CopyToClipboard from "vue-copy-to-clipboard";
import { stateOptions } from "@/utils/states.js";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BLink,
    BTooltip,
    BFormCheckbox,
    BFormRadio,
    flatPickr,
    CopyToClipboard,
    stateOptions,
  },
  data() {
    return {
      items: [],
      shippingDateFrom: "",
      shippingDateTo: "",
      deliveredBy: "",
      city_state: "",
      show_deliverable: false,
      shippingStatusFedex: "destination",
      shippingCity: "",
      shippignItems: [],
      destinationItems: [],
      isLoading: false,
      shippingfields: [
        {
          key: "trackingNumber",
          label: "Tracking Number",
          // sortable: true,
        },
        {
          key: "trackingStatus",
          label: "Status",
          sortable: true,
        },
        {
          key: "shippingDate",
          label: "Shipping Date",
          // sortable: true,
        },
        {
          key: "shippingCity",
          label: "Shipping City",
          // sortable: true,
        },
        {
          key: "deliveryDate",
          label: "Delivery Date",
          // sortable: true,
        },
        {
          key: "deliveryCity",
          label: "Delivery City",
          // sortable: true,
        },
        {
          key: "deliveryState",
          label: "Delivery State",
          // sortable: true,
        },
        {
          key: "weight",
          label: "Weight (kg)",
          // sortable: true,
        },
      ],
      trackerNumber: "",
      copied: {}, // Track copied state
      no_record_found: false,
      trimmedCityState: "",
      trimmedShippingCity: "",
      zipCode: "",
      zipCodeError: "",
      shipping_state: "",
      options: stateOptions,
    };
  },
  mounted() {
    // Set the default value for deliveredBy to ten days before the current date
    this.shippingDateFrom = this.fourDaysBeforeCurrentDate;
    this.shippingDateTo = this.currentDate;
    this.deliveredBy = this.currentDate;
  },
  computed: {
    shippingDateFromInvalid() {
      return (
        this.shippingDateFrom &&
        this.shippingDateTo &&
        new Date(this.shippingDateFrom) >= new Date(this.shippingDateTo)
      );
    },
    shippingDateToInvalid() {
      return (
        this.shippingDateFrom &&
        this.shippingDateTo &&
        new Date(this.shippingDateFrom) >= new Date(this.shippingDateTo)
      );
    },
    currentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    fourDaysBeforeCurrentDate() {
      const date = new Date();
      date.setDate(date.getDate() - 4);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    isCityStateOnlySpaces() {
      return (
        this.city_state.trim() === "" || /^[\s]+[A-Za-z]/.test(this.city_state)
      );
    },
    isShippingCityOnlySpaces() {
      return (
        this.shippingCity.trim() === "" ||
        /^[\s]+[A-Za-z]/.test(this.shippingCity)
      );
    },
  },
  watch: {
    zipCode(newVal) {
      this.validateZipCode(newVal);
    },
    shippingDateTo(newDate) {
      if (newDate !== this.deliveredBy) {
        this.deliveredBy = newDate;
      }
    },
  },
  methods: {
    validateZipCode(value) {
      const trimmedValue = value.replace(/\s+/g, ""); // Remove all spaces
      if (trimmedValue !== value) {
        this.zipCode = trimmedValue; // Update zipCode without spaces
      }

      if (this.zipCode === "") {
        this.zipCodeError = this.$t("usps.zipCodeRequired");
      } else {
        this.zipCodeError = "";
      }
    },

    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const year = d.getFullYear();

      return `${month}/${day}/${year}`;
    },
    handleEyeClick(e) {
      const ipAddress = localStorage.getItem("ip") || "";
      const data = {
        searchId: e.searchId,
        number: Number(e.encode),
        ipAddress: ipAddress,
      };

      const token = useJwt.getToken();
      useJwt
        .DecodeNumber(token, data)
        .then((response) => {
          const trackingNumber = Object.values(response.data)[0]; // Extracting the value from the response
          this.trackerNumber = {
            ...this.trackerNumber,
            [e.encode]: trackingNumber,
          };
          this.copyAffiliateLink(trackingNumber);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    copyAffiliateLink(trackingNumber) {
      navigator.clipboard.writeText(trackingNumber);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Tracking Number Successfully Copied",
          icon: "CheckIcon",
          variant: "success",
        },
      });
      setTimeout(() => {
        this.$set(this.copied, trackingNumber, false);
      }, 2000); // Show the check icon for 2 seconds
    },
    async handleClick() {
      this.isLoading = true;
      const data = {
        shippingDateFrom: this.formatDate(this.shippingDateFrom),
        shippingDateTo: this.formatDate(this.shippingDateTo),
        deliveredBy: this.formatDate(this.deliveredBy),
        // shippingState: this.shipping_state,
        // showDelivered: this.show_deliverable,
        country: "CA",
        carrier: "fedex",
        zipCode: this.zipCode,
      };
      try {
        const token = useJwt.getToken();
        const response = await useJwt.FedexForCanada(token, data);
        this.isLoading = false;
        if (response.data.elements !== "") {
          if (response.data.totalElements === 0) {
            this.no_record_found = true;
            this.destinationItems = [];
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `No Record Found. Please Try another Date Range`,
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.no_record_found = false;
            this.destinationItems = response.data.elements;
          }
        }
      } catch (error) {
        this.isLoading = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${error.response.data.errorMessage}`,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.mt-fedex {
  margin-top: 15px;
}

.mtups-cus {
  margin-top: 26px !important;
}

.py-fedex {
  padding: 1.5rem 0 0 0 !important;
}

.font-bold {
  font-weight: 600;
}

.danger-text {
  position: absolute;
}

@media (max-width: 1526px) {
  //  .py-fedex {
  //   padding: 1.5rem 0 0 0;
  // }

  .mtups-cus {
    margin-top: 24px;
  }
}
</style>
